// extracted by mini-css-extract-plugin
export default {"onlyIconButton":"A257els4xvbX4sF_Xr_U","active":"w9gQA_zYbfsU7ZpJHnlK","ninja":"YJAwy7fBSg1hmUsdkT5M","selected":"r2_vxQYwzf3BwEFEx9XQ","activated":"XLssnlo4YhcIjqNUa1ux"};